import { useNavigate } from 'react-router-dom';
import BaseAppService from '../../../../application/platform/sdp/base/base-app-service';
import OfficialDiaryAppService from '../../../../application/platform/sdp/official-diary/official-diary-app-service';
import SubmissionPublicationAppService from '../../../../application/platform/sep/subimission-publication/subimission-publication-app-service';
import { ACTION_TYPES, useDashboardDispatch } from "./dashboard-context";
import { useBaseLayout } from '../../../../components/context/use-base-layout';

function stringToColor(string: string) {
    let hash = 0;
    let i;

    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
}

function stringAvatar(name: string) {
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
}

export const useDashboardController = () => {
    const navigate = useNavigate();
    const { showLoading } = useBaseLayout();
    const dispatch = useDashboardDispatch();

    async function loadData() {
        try {
            showLoading({ open: true });
            dispatch({ type: ACTION_TYPES.setLoading, payload: true });

            const dashboardData = await BaseAppService.getDashboard();
            dispatch({
                type: ACTION_TYPES.setDashboardDetail,
                payload: dashboardData
            });

            const officialDiaryData = await OfficialDiaryAppService.get({
                page: 0,
                pageSize: 5
            });
            dispatch({
                type: ACTION_TYPES.setOfficialDiaryItems,
                payload: officialDiaryData
            });

            const submissionData = await SubmissionPublicationAppService.get({
                page: 0,
                pageSize: 5
            });
            dispatch({
                type: ACTION_TYPES.setSubmissionPublicationItems,
                payload: submissionData
            });

            dispatch({ type: ACTION_TYPES.setLoading, payload: false });
            showLoading({ open: false });
        } catch (error) {
            console.error(error);
            dispatch({ type: ACTION_TYPES.setLoading, payload: false });
            showLoading({ open: false });
        }
    }

    function handleTabChange(event: any, newTabIndex: number) {
        dispatch({
            type: ACTION_TYPES.setTabIndex,
            payload: newTabIndex
        });
    }

    function navigateToSubmissionPublications() {
        navigate('/remessas-publicacao');
    }

    function navigateToSubmissionPublicationDetail(id: string | number) {
        navigate(`/remessas-publicacao/detalhes/${id}`);
    }

    function navigateToOfficialDiaryDetail(id: string | number) {
        navigate(`/diario-oficial/detalhes/${id}`);
    }

    return {
        loadData,
        handleTabChange,
        navigateToSubmissionPublications,
        navigateToSubmissionPublicationDetail,
        navigateToOfficialDiaryDetail,
        stringAvatar
    };
}
